export enum UserText {
    APP_NAME = 'synqo.cloud',

    // Error Boundary Messages
    ERROR_BOUNDARY_TITLE = 'Ein unerwarteter Fehler ist aufgetreten',
    ERROR_BOUNDARY_MESSAGE = 'Die Anwendung hat einen Fehler festgestellt. Bitte versuchen Sie die Seite neu zu laden.',
    ERROR_TECHNICAL_DETAILS = 'Technische Details',
    ERROR_RELOAD_BUTTON = 'Seite neu laden',
    ERROR_HOME_BUTTON = 'Zur Startseite',

    // Trace ID Labels
    ERROR_TRACE_ID_LABEL = 'Trace-ID',
    ERROR_TRACE_ID_UNAVAILABLE = 'Nicht verfügbar',
    ERROR_TRACE_ID_COPY = 'Kopieren',
    ERROR_TRACE_ID_COPIED = 'Kopiert!',

    // Not Found Messages
    NOT_FOUND_TITLE = 'Objekt nicht gefunden',
    NOT_FOUND_MESSAGE = 'Das angeforderte Objekt konnte nicht geladen werden. Eventuell existiert es nicht, oder Sie haben aus Ihrem jetzigen Mandanten keinen Zugriff darauf.',
    NOT_FOUND_RESOURCE_LABEL = 'Ressource',
}
